const valutes = {
  UAH: '₴',
  EUR: '€',
  USD: '$',
  PLN: 'zł.',
}

export const getValuteSymbol = symbol =>
  symbol ? valutes[symbol] : valutes['UAH']
